import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaMedal, FaUserCircle } from "react-icons/fa";
import { MdFilterList, MdRefresh } from "react-icons/md";
import { TbCoins } from "react-icons/tb";
import "./StreakLeaderboard.css";
import first from "../../assets/TeamsLeaderboard1.png";
import second from "../../assets/TeamsLeaderboard2.png";
import third from "../../assets/TeamsLeaderboard3.png";
import blasterRight from "../../assets/blasterRight.png";
import blasterLeft from "../../assets/blasterLeft.png";
import { FaFilter } from "react-icons/fa";
import { IoRefreshSharp } from "react-icons/io5";
import { GiTwoCoins } from "react-icons/gi";
import moment from "moment-timezone";
import Loader from "components/Loaders/Loader";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { fetchGroups } from "components/API/ApiEnpoints";
import { useCheckSessionHeartBeat } from "components/API/ApiEnpoints";
import { SessionExtend } from "components/utils/SessionCheckUtils";
// @ts-ignore
import confetti from "canvas-confetti";

import {
  FaEnvelope,
  FaPhoneAlt,
  FaBuilding,
  FaGlobe,
  FaCity,
  FaUsers,
} from "react-icons/fa";
import {
  MdOutlineDeviceUnknown,
  MdOutlineNotificationsActive,
} from "react-icons/md";

interface LeaderboardEntry {
  rank: number;
  name: string;
  points: number;
  iconColor?: string;
  image: any;
  unit: string;
  user_uid: string;
  showIcon: boolean;
}

type CustomInputProps = {
  value?: string;
  onClick?: () => void;
};

const groupUids = JSON.parse(localStorage.getItem("group_uids") || "[]");
//const storedGroupNames = JSON.parse(localStorage.getItem("group_names") || "[]");
const Leaderboard: React.FC = () => {
  useCheckSessionHeartBeat();
  const beAddress =
    window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

  const sessionUid = localStorage.getItem("session_uid") || "";
  const userUid = localStorage.getItem("user_uid") || "";

  const navigate = useNavigate();

  const [leaderboard, setLeaderboard] = useState<LeaderboardEntry[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
const [selectedGroup, setSelectedGroup] = useState<string>("__my_org__");
  const [selectedFilter, setSelectedFilter] = useState<string>("steps");
  const [appliedFilter, setAppliedFilter] = useState<string>("steps");
  const [tempFilter, setTempFilter] = useState<string>("steps");
  const [storedGroupNames, setStoredGroupNames] = useState<string[]>([]);
  const [selectedGroupUid, setSelectedGroupUid] = useState<string>("");
  const [filterApplied, setFilterApplied] = useState<boolean>(false);
  const [loadingGroups, setLoadingGroups] = useState<boolean>(true);
  const [fromDatetime, setFromDatetime] = useState<string>("");
  const [toDatetime, setToDatetime] = useState<string>("");
  const [fromDate, setFromDate] = useState<Date | null>(new Date());
  const [toDate, setToDate] = useState<Date | null>(new Date());
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [groupUids, setGroupUids] = useState<string[]>([]);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [isProfilePopupOpen, setIsProfilePopupOpen] = useState<boolean>(false);
  const [userImages, setUserImages] = useState<{ [key: string]: string }>({});
  const [useCustomDateRange, setUseCustomDateRange] = useState(false);
  const [isFilterMode, setIsFilterMode] = useState(false);
  const userPrivilege = localStorage.getItem("privilege");
  const defaultSelectedGroup = "";
  const defaultFromDatetime = moment
    .utc()
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss[Z]");
  const defaultToDatetime = moment
    .utc()
    .endOf("day")
    .format("YYYY-MM-DDTHH:mm:ss[Z]");
  const [isOrgLeaderboard, setIsOrgLeaderboard] = useState(false);
  const [isOrgFilterLeaderboard, setIsOrgFilterLeaderboard] = useState(false);
const [tempGroup, setTempGroup] = useState<string>("__my_org__");
  const [tempFromDate, setTempFromDate] = useState<Date | null>(new Date());
  const [tempToDate, setTempToDate] = useState<Date | null>(new Date());
  const [progress, setProgress] = useState(0);
  const [tempSelectedDuration, setTempSelectedDuration] = useState("weekly");
  const [tempSelectedFilter, setTempSelectedFilter] = useState("steps");
  const [tempSelectedGroup, setTempSelectedGroup] = useState("all");
  const [suppressNextFetch, setSuppressNextFetch] = useState(false);

  const loggedInUser = leaderboard.find((entry) => entry.user_uid === userUid);
  const isSmallList = leaderboard.length <= 5;

  // Create padded top five
  let paddedTopFive: LeaderboardEntry[] = [...leaderboard];

  if (isSmallList) {
    for (let i = paddedTopFive.length; i < 5; i++) {
      paddedTopFive.push({
        rank: i + 1,
        name: "Not yet claimed",
        points: 0,
        unit: "",
        image: null,
        user_uid: `placeholder-${i}`,
        showIcon: true,
      });
    }
  }

  // Always ensure topThree has 3 elements
  const topThree = paddedTopFive.slice(0, 3);
  const isInTop3 = topThree.some((entry) => entry.user_uid === userUid);

  // Build rest of the list (4th & 5th), excluding "You" if shown separately
  const rest = paddedTopFive
    .slice(3)
    .filter((entry) => entry.user_uid !== loggedInUser?.user_uid);

  // Remove user from rest if already in it (to avoid duplicate)
  const filteredRest = rest.filter((entry) => entry.user_uid !== userUid);
  const showUserCard =
    loggedInUser &&
    !topThree.find((entry) => entry.user_uid === loggedInUser.user_uid);

  useEffect(() => {
    const loadGroups = async () => {
      const data = await fetchGroups(sessionUid, userUid, {});
      console.log("Group response:", data);

      if (data && typeof data === "object") {
        const groupNames: string[] = [];
        const groupUids: string[] = [];

        Object.values(data).forEach((categoryGroups) => {
          if (Array.isArray(categoryGroups)) {
            categoryGroups.forEach((group) => {
              if (group.group_name && group.group_uid) {
                groupNames.push(group.group_name);
                groupUids.push(group.group_uid);
              }
            });
          } else {
            console.warn("Skipped non-array category:", categoryGroups);
          }
        });

        setStoredGroupNames(groupNames);
        setGroupUids(groupUids);
        setLoadingGroups(false);
      } else {
        console.error("Invalid group data:", data);
      }
    };

    loadGroups();
  }, []);


  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleApplyFilters = () => {
    setIsPopupOpen(false);
    setIsFilterMode(true);

    if (tempGroup === "__my_org__") {
      setIsOrgFilterLeaderboard(true);
    } else {
      setIsOrgFilterLeaderboard(false);
    }

    setSelectedFilter(tempFilter);
    setAppliedFilter(tempFilter);
    setSelectedGroup(tempGroup);
    setFromDate(tempFromDate);
    setToDate(tempToDate);
    setUseCustomDateRange(true);

    fetchLeaderboard({
      filterType: tempFilter,
      groupName: tempGroup,
      from: tempFromDate,
    });
  };

  const fetchImagesByUid = async (
    imageUids: string[]
  ): Promise<Record<string, string>> => {
    if (!imageUids || imageUids.length === 0) {
      return {};
    }

    try {
      // Build URL with multiple image_uid_list params
      const url = new URL(`${beAddress}/api/get-image-by-uid`);
      imageUids.forEach((uid) =>
        url.searchParams.append("image_uid_list", uid)
      );
      url.searchParams.set("is_icon_img", "true"); // optional, depends on API
      url.searchParams.set("is_feedback_image", "false");

      const res = await fetch(url.toString(), {
        headers: {
          "user-uid": userUid,
        },credentials: "include",
      });

      const data = await res.json();

      if (data.status === "Success" && Array.isArray(data.data)) {
        return Object.fromEntries(
          data.data.map((item: any) => {
            if (item.default) return [item.image_uid, ""]; // default placeholder
            return [item.image_uid, item.image];
          })
        );
      }
      SessionExtend();
    } catch (err) {
      console.error("Failed to fetch images:", err);
    }

    return {};
  };

const fetchLeaderboard = async ({
  filterType = appliedFilter,
  groupName = selectedGroup,
  from = fromDate,
}: {
  filterType?: string;
  groupName?: string;
  from?: Date | null;
} = {}) => {
  setLoading(true);
  setError(null);
  setProgress(0);

  const interval = setInterval(() => {
    setProgress((prev) => Math.min(prev + Math.random() * 2.5, 95));
  }, 300);

  try {
    // Local date, start of day (00:00)
const user_date = moment.utc(from || new Date()) 
  .startOf("day") 
  .format("YYYY-MM-DDTHH:mm:ss[Z]");

    const params: any = { user_date };

    // Only send team_uid if a specific group is selected (not "All" or "My Org")
    if (groupName && groupName !== "__my_org__" && groupName !== "all") {
      const groupIndex = storedGroupNames.indexOf(groupName);
      if (groupIndex !== -1 && groupUids[groupIndex]) {
        params.team_uid = groupUids[groupIndex];
      }
    }

    // If "My Org" is selected
    if (groupName === "__my_org__") {
      params.is_org_leaderboard = true;
    }

    const response = await axios.get(`${beAddress}/api/streak-leaderboard`, {
      headers: { "user-uid": userUid },withCredentials: true,
      params,
    });

    if (response.data?.data) {
      const leaderboardData = response.data.data;
      const imageUids = leaderboardData
        .map((m: any) => m.image_uid)
        .filter(Boolean);

      const imageResponse = await fetchImagesByUid(imageUids);

      const mappedLeaderboard = leaderboardData.map(
          (member: any, index: number) => {
            let imageSrc = "";
            let showIcon = false;

            if (!member.image_uid || member.image_uid === "") {
              showIcon = true; // default image case
            } else if (imageResponse[member.image_uid]) {
              const base64Img = imageResponse[member.image_uid];
              let mimeType = "image/png";

              if (base64Img.startsWith("R0lGODlh")) mimeType = "image/gif";
              else if (base64Img.startsWith("/9j/")) mimeType = "image/jpeg";
              else if (base64Img.startsWith("iVBORw0KGgo"))
                mimeType = "image/png";

              imageSrc = `data:${mimeType};base64,${base64Img}`;
            } else {
              showIcon = true;
            }

            userImages[member.user_uid] = imageSrc;

  return {
    rank: index + 1,
    name: member.user_name,
    points: member.streak_value,
    unit: "Streak",
    image: imageSrc,
    showIcon,
    user_uid: member.user_uid,
  };
});


      setLeaderboard(mappedLeaderboard);
      setUserImages({ ...userImages });

    }

    SessionExtend();
  } catch (err) {
    setError("Failed to fetch leaderboard.");
    console.error(err);
  } finally {
    clearInterval(interval);
    setProgress(100);
    setTimeout(() => {
      setLoading(false);
      setProgress(0);
    }, 500);
  }
};

useEffect(() => {
  fetchLeaderboard({
    filterType: appliedFilter,
    groupName: "__my_org__",
    from: new Date(),
  }); 
}, []);


  const CustomInput = React.forwardRef<HTMLInputElement, CustomInputProps>(
    ({ value, onClick }, ref) => (
      <input
        className="leaderboard-datepicker"
        onClick={onClick}
        value={value}
        readOnly
        ref={ref}
      />
    )
  );

  const getStatusInfo = (status: string) => {
    switch (status) {
      case "active":
        return { color: "#16821aff", label: "Online", iconname: "checkcircle" }; // green 16821aff
      case "away":
        return { color: "#f6c70aff", label: "Away", iconname: "clockcircle" }; // yellow f6c70aff
      case "invited":
        return {
          color: "#000000",
          label: "Inactive",
          iconname: "exclamationcircle",
        }; // black
      default:
        return {
          color: "#9b9292ff",
          label: "Offline",
          iconname: "closecircle",
        }; // black
    }
  };

  const profileImage = userProfile?.image?.trim() || null;

    
    const profileImageStyle: React.CSSProperties = {
  width: "40px",
  height: "40px",
  borderRadius: "50%",
};

    const fireSideConfetti = () => {
      // Left cannon
      confetti({
        particleCount: 60,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.4 },
        colors: ["#ffae00", "#ff0055", "#00c8ff", "#00ff88"],
      });
  
      // Right cannon
      confetti({
        particleCount: 60,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.4 },
        colors: ["#ffae00", "#ff0055", "#00c8ff", "#00ff88"],
      });
  
      // Floating soft rain
      var duration = 2 * 1000;
      var end = Date.now() + duration;
  
      (function frame() {
        confetti({
          particleCount: 3,
          startVelocity: 20,
          ticks: 300,
          origin: { x: Math.random(), y: -0.1 }
        });
  
        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      })();
    };
    useEffect(() => {
      if (!loading && leaderboard.length > 0) {
        fireSideConfetti();
      }
    }, [loading]);
    
  return (
    <>
      {loading && (
        <div className="progress-bar-container">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      )}

      {userPrivilege === "systemadmin" ? (
        <div className="access-denied-message">Access Denied</div>
      ) : (
        <>
          {/* <img src={blasterLeft} alt="Blaster Left" className="blaster left" />
          <img
            src={blasterRight}
            alt="Blaster Right"
            className="blaster right"
          /> */}

          <div className="leaderboard-title">STREAK LEADERBOARD</div>
          {loading ? (
            <Loader />
          ) : (
            <>
              {/* {isFilterMode && ( */}
                <div className="filter-bar">
                  <div className="filter-item" onClick={togglePopup}>
                    <FaFilter className="filter-icon" />
                    <span>Filter By</span>
                  </div>
                  <div className="applied-filters">
                    {(selectedGroup !== undefined ||
                      selectedFilter !== undefined ||
                      useCustomDateRange) && (
                      <span>
                        <strong>Applied Filters:</strong>
                      </span>
                    )}
                    <span>
                      {" "}
                      Group:{" "}
                      {selectedGroup === "__my_org__"
                        ? "My Org"
                        : selectedGroup || "All"}
                    </span>
                    {/* <span>
                      {" "}
                      | Metric:{" "}
                      {selectedFilter ? selectedFilter : "Overall Performance"}
                    </span> */}
                    {fromDate && (
                      <span> | Date: {fromDate.toLocaleDateString()}</span>
                    )}
                    {/* {useCustomDateRange && toDate && (
                      <span> | To: {toDate.toLocaleDateString()}</span>
                    )} */}
                  </div>

                </div>
              {/* )} */}
              {isPopupOpen && (
                <div className="leaderboard-popup">
                  <div className="leaderboard-popup-content">
                    <span className="leaderboard-close" onClick={togglePopup}>
                      &times;
                    </span>
                    <h2 className="leaderboard-popup-title">Select Filters</h2>

                    <div className="leaderboard-filter-group">
                      <label className="leaderboard-label">Select Group:</label>
                      <select
                        className="leaderboard-select"
                        value={tempGroup}
                        onChange={(e) => {
                          const groupName = e.target.value;
                          setTempGroup(groupName);

                          if (groupName === "__my_org__") {
                            setIsOrgFilterLeaderboard(true);
                          } else {
                            setIsOrgFilterLeaderboard(false);
                            const groupIndex =
                              storedGroupNames.indexOf(groupName);
                            if (groupIndex !== -1) {
                              setSelectedGroupUid(groupUids[groupIndex]);
                            } else {
                              setSelectedGroupUid("");
                            }
                          }
                        }}
                      >
                        <option value="">All</option>
                        <option value="__my_org__">My Org</option>
                        {storedGroupNames.map((groupName, index) => (
                          <option key={index} value={groupName}>
                            {groupName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="leaderboard-filter-group">
                      <label className="leaderboard-label">Date:</label>
                      <DatePicker
                        selected={tempFromDate}
                        onChange={(date) => {
                          setTempFromDate(date);
                          setUseCustomDateRange(true);
                        }}
                        maxDate={new Date()}
                        dateFormat="yyyy-MM-dd"
                        className="leaderboard-datepicker"
                        customInput={<CustomInput />}
                      />
                    </div>
                    <button
                      className="leaderboard-apply-button"
                      onClick={handleApplyFilters}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}

              <div className="leaderboard-members-list">
                {topThree.map((member, index) => (
                  <div
                    key={member.user_uid}
                    className={`leaderboard-member-card ${
                      index === 0
                        ? "first-place"
                        : index === 1
                        ? "second-place"
                        : "third-place"
                    }`}
  
                  >
                    {member.showIcon ? (
                      <FaUserCircle
                        style={{ fontSize: "100px", color: "gray" }}
                      />
                    ) : (
                      <img
                        src={member.image}
                        alt={member.name}
                        className="leaderboard-image"
                      />
                    )}
                    <div className="leaderboard-progress-circle">
                      {member.rank}
                    </div>
                    <div className="leaderboard-member-info">
                      <p className="leaderboard-name">
                        {member.user_uid.startsWith("placeholder")
                          ? "Not yet claimed"
                          : member.name}
                      </p>
                      <span className="leaderboard-points">
                        {member.user_uid.startsWith("placeholder")
                          ? "--"
                          : `${member.points} ${member.unit}`}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="leaderboard-list">
                {loggedInUser && !isInTop3 && (
                  <div
                    key={"you-highlight"}
                    className="leaderboard-list-item you-highlight"
                  >
                    <div className="leaderboard-list-item1">
                      <div className="leaderboard-rank-list1">
                        {loggedInUser.rank}
                      </div>
                      <div className="leadership-name-image-container">
                        {loggedInUser.showIcon ? (
                          <FaUserCircle
                            style={{ fontSize: "40px", color: "black" }}
                          />
                        ) : (
                          <img
                            src={loggedInUser.image}
                            alt={loggedInUser.name}
                            className="leaderboard-list-image"
                          />
                        )}
                        <p className="leaderboard-list-name">
                          {loggedInUser.name}{" "}
                          <span style={{ fontWeight: 500 }}>(You)</span>
                        </p>
                      </div>
                    </div>
                    <div className="leaderboard-list-points">
                      {loggedInUser.points} {loggedInUser.unit}
                    </div>
                  </div>
                )}

                {rest.map((member) => (
                  <div
                    key={member.user_uid}
                    className="leaderboard-list-item"
                  >
                    <div className="leaderboard-list-item1">
                      <div className="leaderboard-rank-list1">
                        {member.rank}
                      </div>
                      <div className="leadership-name-image-container">
                        {member.showIcon ? (
                          <FaUserCircle
                            style={{ fontSize: "40px", color: "gray" }}
                          />
                        ) : (
                          <img
                            src={member.image}
                            alt={member.name}
                            className="leaderboard-list-image"
                          />
                        )}
                        <p className="leaderboard-list-name">
                          {member.user_uid.startsWith("placeholder")
                            ? "Not yet claimed"
                            : member.name}
                        </p>
                      </div>
                    </div>
                    <div className="leaderboard-list-points">
                      {member.user_uid.startsWith("placeholder")
                        ? "--"
                        : `${member.points} ${member.unit}`}
                    </div>
                  </div>
                ))}
              </div>

              {isProfilePopupOpen && userProfile && (
                <div
                  className="member-profile-popup"
                  onClick={() => setIsProfilePopupOpen(false)}
                >
                  <div
                    className="member-profile-popup-content"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span
                      className="member-profile-close"
                      onClick={() => setIsProfilePopupOpen(false)}
                    >
                      &times;
                    </span>

                    <div className="member-profile-header">
                      
                      {profileImage ? (
  <img
    src={profileImage}
    alt={`${userProfile.first_name} ${userProfile.last_name}`}
    className="member-profile-image"
   style={profileImageStyle}
    onError={(e) => {
      (e.target as HTMLImageElement).onerror = null;
      (e.target as HTMLImageElement).style.display = "none";
    }}
  />
) : (
                        <FaUserCircle
                          className="member-profile-placeholder"
                          style={{
                            color: getStatusInfo(userProfile.user_online_status)
                              .color,
                            border: `3px solid ${
                              getStatusInfo(userProfile.user_online_status)
                                .color
                            }`,
                            borderRadius: "50%",
                            padding: "3px",
                          }}
                        />
                      )}
                      <div
                        style={{
                          textAlign: "center",
                          marginTop: "2px",
                          fontWeight: "500",
                          color: getStatusInfo(userProfile.user_online_status)
                            .color,
                        }}
                      >
                        {getStatusInfo(userProfile.user_online_status).label}
                      </div>
                      <div className="member-name-job">
                        <h2 className="member-name">{`${userProfile.first_name} ${userProfile.last_name}`}</h2>
                        <p className="member-job-title">
                          {userProfile.job_title || "—"}
                        </p>
                      </div>
                    </div>

                    <div className="leaderboard-member-details">
                      <div className="leaderboard-popup-row">
                        <FaEnvelope className="leaderboard-popup-icon" />
                        <div className="leaderboard-popup-text">
                          <div className="leaderboard-popup-label">Email:</div>
                          <div className="leaderboard-popup-value">
                            {userProfile.email || "—"}
                          </div>
                        </div>
                      </div>

                      <div className="leaderboard-popup-row">
                        <FaPhoneAlt className="leaderboard-popup-icon" />
                        <div className="leaderboard-popup-text">
                          <div className="leaderboard-popup-label">Mobile:</div>
                          <div className="leaderboard-popup-value">
                            {userProfile.mobile_phone || "—"}
                          </div>
                        </div>
                      </div>

                      <div className="leaderboard-popup-row">
                        <FaBuilding className="leaderboard-popup-icon" />
                        <div className="leaderboard-popup-text">
                          <div className="leaderboard-popup-label">
                            Department:
                          </div>
                          <div className="leaderboard-popup-value">
                            {userProfile.department || "—"}
                          </div>
                        </div>
                      </div>

                      <div className="leaderboard-popup-row">
                        <FaGlobe className="leaderboard-popup-icon" />
                        <div className="leaderboard-popup-text">
                          <div className="leaderboard-popup-label">
                            Nationality:
                          </div>
                          <div className="leaderboard-popup-value">
                            {userProfile.nationality || "—"}
                          </div>
                        </div>
                      </div>

                      <div className="leaderboard-popup-row">
                        <FaCity className="leaderboard-popup-icon" />
                        <div className="leaderboard-popup-text">
                          <div className="leaderboard-popup-label">City:</div>
                          <div className="leaderboard-popup-value">
                            {userProfile.city || "—"}
                          </div>
                        </div>
                      </div>

                      <div className="leaderboard-popup-row">
                        <MdOutlineDeviceUnknown className="leaderboard-popup-icon" />
                        <div className="leaderboard-popup-text">
                          <div className="leaderboard-popup-label">
                            Device type:
                          </div>
                          <div className="leaderboard-popup-value">
                            {userProfile.device_type || "-"}
                          </div>
                        </div>
                      </div>
                      <div className="leaderboard-popup-row">
                        <MdOutlineNotificationsActive className="leaderboard-popup-icon" />
                        <div className="leaderboard-popup-text">
                          <div className="leaderboard-popup-label">
                            Last Active:
                          </div>
                          <div className="leaderboard-popup-value">
                            {userProfile?.last_active
                              ? new Date(
                                  userProfile.last_active
                                ).toLocaleString()
                              : "Never logged in"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Leaderboard;
